/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-container>
      <v-dialog v-model="errorLog" max-width="290">
        <v-card>
          <v-card-text>
            {{error_message}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click="errorLog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card class="ma-2 pa-2">
        <v-form method="POST" enctype="multipart/form-data" v-model="valid" ref="myForm"
          id="fileUploadForm">
          <v-text-field type="hidden" ref="fileTextField" v-model="plantId" style="display:none"
            name="plantId">
          </v-text-field>
          <input type="file" name="file" id="selectedFile" style="display: none" />
          <v-layout style="justify-content: center">

            <v-flex xs3 sm4 md2>
              <v-btn color="primary" @click="handleFileSelect">Browse
                <v-icon medium right>
                  attach_file
                </v-icon>
              </v-btn>
            </v-flex>

            <v-flex xs3 sm4 md6>
              <v-chip class="ma-2" disabled>File Name : {{filePath}}</v-chip>
            </v-flex>

            <v-flex xs3 sm4 md4>
              <v-tooltip bottom>
                <template slot="activator">
                  <v-btn @click="uploadDocsHandler" color="success">Upload
                    <v-icon right>
                      cloud_upload
                    </v-icon>
                  </v-btn>
                </template>
                <span>Upload Excel File</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template slot="activator">
                  <v-btn color="success" @click="fetchTemplate">Download
                    <v-icon right>
                      cloud_download
                    </v-icon>
                  </v-btn>
                </template>
                <span>Download Template</span>
              </v-tooltip>
            </v-flex>

          </v-layout>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import {
  Api
} from '../services/Api'

import AdminService from '@/services/zmuConfig.js'

export default {
  data: () => ({
    dialog: false,
    errorLog: false,
    error_message: '',
    valid: null,
    headers: [{
      text: 'DOCUMENTS',
      align: 'left',
      sortable: false,
      value: 'name'
    },
    {
      text: 'ACTIONS',
      align: 'right',
      value: 'name',
      sortable: false
    }
    ],
    docs: [],
    editedIndex: -1,
    editedItem: {
      name: ''
    },
    defaultItem: {
      name: ''
    },
    file: null,
    filePath: '',
    plantId: null
  }),
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantInfo'])
  },
  watch: {
    file() {
      this.filePath = this.file.replace('C:\\fakepath\\', '')
    }
  },
  mounted() {
    this.plantId = this.getSelectedPlantId
    document.getElementById('selectedFile').addEventListener('change', e => {
      this.file = e.target.value
    })
  },
  methods: {
    handleFileSelect(e) {
      document.getElementById('selectedFile').click()
    },
    uploadDocsHandler() {
      console.log(this.$refs.myForm.$el.querySelector('input[type=file]').value, 'FILE VALUE')
      if (this.$refs.myForm.$el.querySelector('input[type=file]').value == '') {
        this.error_message = 'Please select a file to upload'
        this.errorLog = true
      } else {
        let form = this.$refs.myForm.$el
        let data = new FormData(form)
        Api().post(`/api/v2/zmu/admin/update/${this.getSelectedPlantId}`, data)
          .then(res => {
            const reset = {
              resetZmuConfig: true
            }
            AdminService.zmuCacheRefresh(reset)
            this.error_message = 'Upload Successfull'
            this.errorLog = true
            this.filePath = ''
            this.$refs.myForm.$el.querySelector('input[type=file]').value = null
          })
          .catch(() => {
            this.error_message = 'Upload Failed'
            this.errorLog = true
          })
      }
    },
    fetchTemplate() {
      AdminService.fetchTemplate(this.getSelectedPlantId, this.getActivePlantInfo('plant_name'))
    }
  }
}
</script>
